import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { getFieldErrorList } from '../../helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFieldErrors',
  props: makeUseFormElementProps<FieldModel>(),
  emits: makeUseFormElementEmits(),
  setup(__props, { emit }) {

const props = __props;





const formElement = useFormElement({
  emit,
  props,
});

const { fieldErrorsShown } = useBaseFieldValues(formElement);

const { field, model, getSlotName } = formElement;

const fieldErrors = computed(() => getFieldErrorList(field.value, model.value));

return { __sfc: true,props, emit, formElement, fieldErrorsShown, field, model, getSlotName, fieldErrors }
}

})